// @github/hotkey decides what `Mod` means from `navigator.platform`; matching that exact
// test is what keeps the key we DISPLAY the same as the key that is actually bound.
export const APPLE_PLATFORM = /Mac|iPod|iPhone|iPad/i.test(navigator.platform)

// The server writes the platform keys of position_grid/_keys as words; Apple platforms read them
// as glyphs — the modifiers, and Entf, which a Mac keyboard does not have: the grid takes ⌫ there.
const APPLE_GLYPHS = { Mod: "⌘", Shift: "⇧", Alt: "⌥", Delete: "⌫" }

export function applyPlatformKeys(root) {
  if (!APPLE_PLATFORM) return

  root.querySelectorAll("kbd[data-platform-key]").forEach((kbd) => {
    kbd.textContent = APPLE_GLYPHS[kbd.dataset.platformKey] ?? kbd.textContent
  })
}
